import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ARCHIVE_API_PATH } from '../pages/achievements/shared';
import { forecastAPI } from '../services/api';

// Guests only see Achievements and Forecasts once something is actually published there.
// Signed-in users always see both, so the check only runs for guests.
// null means "not checked yet": links stay hidden, but routes stay reachable so a
// direct link is not redirected away before the answer arrives.
export default function usePublicSections() {
  const { user } = useContext(AuthContext);
  const [sections, setSections] = useState({ achievements: null, forecasts: null });

  useEffect(() => {
    if (user) {
      setSections({ achievements: true, forecasts: true });
      return undefined;
    }

    let active = true;
    Promise.all([
      fetch(ARCHIVE_API_PATH).then((response) => (response.ok ? response.json() : { items: [] })).catch(() => ({ items: [] })),
      forecastAPI.getForecasts(0, 1).catch(() => []),
    ]).then(([archive, forecasts]) => {
      if (!active) return;
      setSections({
        achievements: (archive.items || []).some((item) => item.isPublished),
        forecasts: (forecasts || []).length > 0,
      });
    });

    return () => {
      active = false;
    };
  }, [user]);

  return sections;
}
